export default "__VITE_ASSET__BbLIsCBu__"